import { getApiBaseUrl } from "./environment";

// Use centralized environment configuration
export const BASE_URL = getApiBaseUrl();
